import { render, staticRenderFns } from "./Backgrounds.vue?vue&type=template&id=5c1c60b6&scoped=true"
import script from "./Backgrounds.vue?vue&type=script&lang=js"
export * from "./Backgrounds.vue?vue&type=script&lang=js"
import style0 from "./Backgrounds.vue?vue&type=style&index=0&id=5c1c60b6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1c60b6",
  null
  
)

export default component.exports